interface IBreadcrumbJsonldItem {
	title: string
	href: string
}

export const useBreadcrumbJsonld = (items: MaybeRefOrGetter<IBreadcrumbJsonldItem[] | undefined>) => {
	const url = useRequestURL()

	useJsonld(() => {
		const breadcrumbs = toValue(items) ?? []
		if (!breadcrumbs.length) return {}

		return {
			'@context': 'https://schema.org',
			'@type': 'BreadcrumbList',
			itemListElement: breadcrumbs.map((breadcrumb, index) => ({
				'@type': 'ListItem',
				position: index + 1,
				name: breadcrumb.title,
				item: new URL(breadcrumb.href, url.origin).href,
			})),
		}
	})
}
